/* eslint-disable react/prop-types */
import React from 'react';
import { Sparkles, Stethoscope, Building2, Sun, GraduationCap, Dumbbell,
  Home, Briefcase, HeartHandshake, Send, Landmark, Megaphone, Users } from 'lucide-react';

const ICON_MAP = {
  Users, Stethoscope, Building2, Sun, GraduationCap, Dumbbell,
  Sparkles, Home, Briefcase, HeartHandshake, Send, Landmark, Megaphone,
};

export default function EcosystemBadge({ ecosystem, compact = false }) {
  if (!ecosystem) return null;
  const Icon = ICON_MAP[ecosystem.icon] || Users;
  return (
    <span
      data-testid={`ecosystem-badge-${ecosystem.code}`}
      className="inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] uppercase tracking-[0.14em] font-['Work_Sans']"
      style={{
        borderColor: ecosystem.color || '#D8D4CE',
        color: ecosystem.color || '#5C5955',
        backgroundColor: `${ecosystem.color || '#D8D4CE'}12`,
      }}
    >
      <Icon className="w-3 h-3" strokeWidth={1.5} />
      {!compact && (ecosystem.name || ecosystem.code)}
    </span>
  );
}
